import { gql } from '@apollo/client';

const GROUPS_FRAGMENT = gql`
  fragment BaseGroups on Group {
    id
    appId
    classroomId
    name
    groupCategory {
      appId
      classroomId
      name
    }
  }
`;

export default GROUPS_FRAGMENT;
